module.exports = __webpack_public_path__ + "static/img/170903-down-syndrome.02f22e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/170903-down-syndrome.jpg
// module id = SeTb
// module chunks = 0